import {Link} from 'react-router-dom';
import styled from "styled-components";

import {useMatch} from '../utils/router';

const NavLink = styled(function NavLink({href, active, activeOnlyWhenExact, className, children, onClick, react_route, ...props}) {
    const matches = useMatch(href, {active, exact: activeOnlyWhenExact});
    return (
        <Link

            className={matches ? `${className} active` : className}
            to={href}
            onClick={(event) => {
                event.stopPropagation();
                if (typeof onClick === 'function') {
                    onClick(event);
                }
            }}
            {...props}
        >
            {children}
        </Link>
    );
})``;

export default NavLink;
